import React from 'react';
import PropTypes from 'prop-types';
import BuildChildren from 'utils/BuildChildren';
import classNames from 'classnames';

const CardImageFooterA = (props) => {
  const {
    footerChildren = [],
    classes = {},
    containerKey = '',
  } = props;

  return footerChildren.length > 0 && (
    <div className={classes.footerWrapper}>
      {footerChildren.map((item, i) => {
        const isLink = item.type === 'Link';
        const { title, ...rest } = item;
        const linkTitle = `${title}<span class='${classes.linkChevron}'></span>`;
        return (
          <div className={classes.itemContainer} key={`${containerKey}-${i}`}>
            <div className={classNames({ [classes.link]: isLink, [classes.button]: !isLink })} key={i}>
              {isLink
                ? <div className={classes.linkAnchor}>{BuildChildren({ title: linkTitle, ...rest })}</div>
                : BuildChildren(item)}
            </div>
          </div>
        );
      })}
    </div>
  );
};

CardImageFooterA.propTypes = {
  footerChildren: PropTypes.array,
  classes: PropTypes.object,
  containerKey: PropTypes.string,
};

export default CardImageFooterA;
